import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var UrlShortcutSvg = function UrlShortcutSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C8C8C8",
    fillRule: "evenodd",
    d: "M2 0h20a2 2 0 0 1 2 2v20a2 2 0 0 1-2 2H8.708A9 9 0 0 0 0 9.223V2a2 2 0 0 1 2-2",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#171717",
    fillRule: "evenodd",
    d: "m9.186 11.516-.175-.006a3.5 3.5 0 0 0-.706.067q.447.44.83.937a.5.5 0 0 0 .05-.998m1.082 2.923a9 9 0 0 0-.473-.941l5.352-5.35a.5.5 0 0 1 .755.651l-.048.056zm.628 2.191q.1.647.104 1.32l.475-.474.12-.127a3.48 3.48 0 0 0 .892-2.533.5.5 0 0 0-.998.058 2.48 2.48 0 0 1-.593 1.756m8.985-10.037a3.5 3.5 0 0 0-5.856-1.568l-1.5 1.5-.12.126a3.48 3.48 0 0 0-.889 2.533.5.5 0 0 0 .999-.058 2.48 2.48 0 0 1 .718-1.896l1.5-1.498.107-.102a2.5 2.5 0 0 1 3.428 3.636l-1.5 1.5-.11.102a2.48 2.48 0 0 1-1.786.618.5.5 0 1 0-.057.998 3.48 3.48 0 0 0 2.66-1.012l1.5-1.5.112-.117a3.5 3.5 0 0 0 .794-3.262",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.313 23.583q-1.793 0-3.053-1.245T0 19.295q0-1.27.647-2.288a4.36 4.36 0 0 1 1.725-1.57H0V14h5.39v5.39H3.954v-2.97a2.72 2.72 0 0 0-1.797.934 2.8 2.8 0 0 0-.719 1.917q0 1.201.839 2.038a2.78 2.78 0 0 0 2.037.837z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))));
};
export var UrlShortcut = function UrlShortcut(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: UrlShortcutSvg
  }));
};